// Just a shortcut for bulk export

import parseLinkDestination from './parse-link-destination'
import parseLinkLabel from './parse-link-label'
import parseLinkTitle from './parse-link-title'
import { parseAttributeBlock } from './parse-attribute-block'
import { parseAttributes } from './parse-attributes'

export const helpers = {
  parseLinkDestination,
  parseLinkLabel,
  parseLinkTitle,
  parseAttributeBlock,
  parseAttributes,
}
